export default  {	
	data () {
		return { 
			filter: {
				inicial: this.fecha().fecha.minHoy,
				final: this.fecha().fecha.minHoy,
				id_datos_asesor: null,
				id_datos_razon: null
			}
		}
	},
	async created () { 
		// frontend this.searchGetIdb({tabla:'info_ingresos'})
	},
}
